import type {
	CustomItem,
	DropImageCarouselType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropImageCarousel = (
	item: Item | CustomItem
): item is DropImageCarouselType => {
	return !!(item && item.__typename === 'Drop_Image_Carousel');
};
